import { render } from "./IndividualClient.vue?vue&type=template&id=5230398d&scoped=true"
import script from "./IndividualClient.vue?vue&type=script&lang=js"
export * from "./IndividualClient.vue?vue&type=script&lang=js"

import "./IndividualClient.vue?vue&type=style&index=0&id=5230398d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5230398d"]])

export default __exports__